import { ConfigProvider } from "antd";
import MainLayout from "../../layouts/Layout";
import styles from "./user.module.scss";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { userAtom } from "../../store/atoms";
import { UserOutlined } from "@ant-design/icons";
import { AddUserForm } from "./AddUserForm";
import { canManageUserAccounts } from "../../constants/roles";

const AddNewUser = () => {
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);

  useEffect(() => {
    if (!user || !canManageUserAccounts(user.role)) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <ConfigProvider getPopupContainer={(triggerNode) => triggerNode?.parentNode as HTMLElement}>
      <MainLayout title="Add New User" icon={<UserOutlined />}>
        <div className={styles.formContainer}>
          <AddUserForm onCancel={() => navigate(-1)} />
        </div>
      </MainLayout>
    </ConfigProvider>
  );
};

export default AddNewUser;
